import { Flex, Text } from '@chakra-ui/react';
import { CratIcon } from '../CratIcon/CratIcon';
import React from 'react';

export const CratLogo = React.memo(() => {
  return (
    <Flex alignItems={'center'} gap={'9px'}>
      <CratIcon w={'35px'} h={'39px'} />
      <Text fontWeight={600} fontSize={'22px'} lineHeight={'23px'} as={'h2'}>
        CratD2C
      </Text>
    </Flex>
  );
});
